import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Icon from '../components/pages/demo/components/Icon';
import TabMenu from '../components/pages/demo/components/TabMenu';
import Pill from '../components/pages/demo/components/Pill';
import Menu from '../components/pages/demo/components/Menu';
import SelectDropdown from '../components/pages/demo/components/SelectDropdown';
import LoadingIndicator from '../components/pages/demo/components/LoadingIndicator';
import Accordion from '../components/pages/demo/components/Accordion';
import AnimatedCard from '../components/pages/demo/components/AnimatedCard';
import Banner from '../components/pages/demo/components/Banner';
import Button from '../components/pages/demo/components/Button';
import CardGrid from '../components/pages/demo/components/CardGrid';
import Checkbox from '../components/pages/demo/components/Checkbox';
import Dialog from '../components/pages/demo/components/Dialog';
import DataGrid from '../components/pages/demo/components/DataGrid';
import Drawer from '../components/pages/demo/components/Drawer';
import DemoUserProfile from '../components/pages/demo/components/UserProfile';
import GroupAvatar from '../components/pages/demo/components/GroupAvatar';
import LoadingButton from '../components/pages/demo/components/LoadingButton';
import ServiceAgreementSelect from '../components/pages/demo/components/ServiceAgreementSelect';
import PageHeader from '../components/pages/demo/components/PageHeader';
import Pagination from '../components/pages/demo/components/Pagination';
import DemoPieChart from '../components/pages/demo/components/PieChart';
import PaginationPro from '../components/pages/demo/components/PaginationPro';
import Popup from '../components/pages/demo/components/Popup';
import ProfilePicture from '../components/pages/demo/components/ProfilePicture';
import ProgressBar from '../components/pages/demo/components/ProgressBar';
import SearchBox from '../components/pages/demo/components/SearchBox';
import Select from '../components/pages/demo/components/Select';
import StepperTab from '../components/pages/demo/components/StepperTab';
import SvgIcon from '../components/pages/demo/components/SvgIcon';
import Switch from '../components/pages/demo/components/Switch';
import Toast from '../components/pages/demo/components/Toast';
import Demo from '../components/pages/demo/Demo';
import Infographic from '../components/pages/demo/components/Infographic';
import DrawerNavigation from '../components/pages/demo/components/DrawerNavigation';
import DatePicker from '../components/pages/demo/components/DatePicker';
import ProgressBarChart from '../components/pages/demo/components/ProgressBarChart';
import Alerts from '../components/pages/demo/components/Alerts';
import DataGridPro from '../components/pages/demo/components/DataGridPro';
import Chip from '../components/pages/demo/components/Chip';
import PizzaTrackerProgress from '../components/pages/demo/components/PizzaTrackerProgress';
import PermissionGroupSelect from '../components/pages/demo/components/PermissionGroupSelect';
import EcaBadges from '../components/pages/demo/components/EcaBadges';
import ECAPermissionStatus from '../components/pages/demo/components/ECAPermissionStatus';
import AdhocSearch from '../components/pages/demo/components/AdhocSearch';
import TabWithIcons from '../components/pages/demo/components/TabWithIcons';
import DataGridTree from '../components/pages/demo/components/DataGridTree';
import EcaSearchLoader from '../components/pages/demo/components/EcaSearchLoader';
import CountryFlagComponent from '../components/pages/demo/components/CountryFlagComponent';
import TagSelectList from '../components/pages/demo/components/TagSelectList';
import IndexingBannerComponent from '../components/pages/demo/components/IndexingBannerComponent';
import IndexingOverviewPage from '../components/pages/demo/components/IndexingOverviewPage';
import Acknowledgement from '../components/pages/demo/components/Acknowledgement';
import ProgressBarStripe from '../components/pages/demo/components/ProgressBarStripe';
import AurManageClientDropdown from '../components/common/aur-manage-client-dropdown/AurManageClientDropdown';
import VideoController from '../components/pages/demo/components/VideoController';

const DemoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Demo />} />
      <Route path="components/Accordion" element={<Accordion />} />
      <Route path="components/AnimatedCard" element={<AnimatedCard />} />
      <Route path="components/Acknowledgement" element={<Acknowledgement />} />
      <Route
        path="components/ProgressBarStripe"
        element={<ProgressBarStripe />}
      />
      <Route path="components/Banner" element={<Banner />} />
      <Route path="components/Button" element={<Button />} />
      <Route path="components/CardGrid" element={<CardGrid />} />
      <Route path="components/Checkbox" element={<Checkbox />} />
      <Route path="components/DataGrid" element={<DataGrid />} />
      <Route path="components/Dialog" element={<Dialog />} />
      <Route path="components/Drawer" element={<Drawer />} />
      <Route path="components/Icon" element={<Icon />} />
      <Route
        path="components/IndexingBanner"
        element={<IndexingBannerComponent />}
      />
      <Route
        path="components/IndexingOverviewPage"
        element={<IndexingOverviewPage />}
      />
      <Route path="components/GroupAvatar" element={<GroupAvatar />} />
      <Route path="components/LoadingButton" element={<LoadingButton />} />
      <Route path="components/ServiceAgreementSelect" element={<ServiceAgreementSelect />} />
      <Route
        path="components/LoadingIndicator"
        element={<LoadingIndicator />}
      />
      <Route path="components/AurManageClientDropdown" element={<AurManageClientDropdown />} />
      <Route path="components/Menu" element={<Menu />} />
      <Route path="components/Pagination" element={<Pagination />} />
      <Route path="components/PaginationPro" element={<PaginationPro />} />
      <Route path="components/PageHeader" element={<PageHeader />} />
      <Route path="components/Pill" element={<Pill />} />
      <Route path="components/Popup" element={<Popup />} />
      <Route path="components/PieChart" element={<DemoPieChart />} />
      <Route path="components/ProfilePicture" element={<ProfilePicture />} />
      <Route path="components/Progressbar" element={<ProgressBar />} />
      <Route path="components/SearchBox" element={<SearchBox />} />
      <Route path="components/SelectDropdown" element={<SelectDropdown />} />
      <Route path="components/Select" element={<Select />} />
      <Route path="components/StepperTab" element={<StepperTab />} />
      <Route path="components/SvgIcon" element={<SvgIcon />} />
      <Route path="components/Switch" element={<Switch />} />
      <Route path="components/TabMenu" element={<TabMenu />} />
      <Route path="components/Toast" element={<Toast />} />
      <Route path="components/UserProfile" element={<DemoUserProfile />} />
      <Route path="components/Infographic" element={<Infographic />} />
      <Route
        path="components/DrawerNavigation"
        element={<DrawerNavigation />}
      />
      <Route path="components/DatePicker" element={<DatePicker />} />
      <Route
        path="components/ECAPermissionStatus"
        element={<ECAPermissionStatus />}
      />
      <Route path="components/ProgressChart" element={<ProgressBarChart />} />
      <Route path="components/Alerts" element={<Alerts />} />
      <Route path="components/DataGridPro" element={<DataGridPro />} />
      <Route path="components/Chip" element={<Chip />} />
      <Route
        path="components/PizzaTrackerProgress"
        element={<PizzaTrackerProgress />}
      />
      <Route
        path="components/PermissionGroupSelect"
        element={<PermissionGroupSelect />}
      />
      <Route path="components/EcaBadges" element={<EcaBadges />} />
      <Route path="components/AdhocSearch" element={<AdhocSearch />} />
      <Route path="components/TabWithIcons" element={<TabWithIcons />} />
      <Route path="components/DataGridTree" element={<DataGridTree />} />
      <Route path="components/EcaSearchLoader" element={<EcaSearchLoader />} />
      <Route path="components/CountryFlag" element={<CountryFlagComponent />} />
      <Route path="components/TagSelectList" element={<TagSelectList />} />
      <Route
        path="components/VideoController"
        element={<VideoController />}
      />
    </Routes>
  );
};

export default DemoRoutes;
